function initListDisplay(el, it) {
  $(el).each(function callback() {
    $(this).find('[class^="col"]').each((i, currentEl) => {
      if (i % it === 0) {
        $(currentEl).addClass('colNthChild2n');
      }
    });
  });
}

module.exports = initListDisplay;
